export default __webpack_public_path__ + "static/822-2479146719f1bbbbd0bcec299ff491fd.gif";